module.exports = __webpack_public_path__ + "static/img/legend_xa_spanish_vertical.7e7d70d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_spanish_vertical.png
// module id = wdY6
// module chunks = 79